import React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { USER_CATEGORIES, userCategoryAdminLabel, UserCategoryFilter } from '@finance-lab/utils/types'

interface UsersFilterProps {
    filterState: { userCategory: UserCategoryFilter }
    setFilterState: (filterState: { userCategory: UserCategoryFilter }) => void
}

function UsersFilter({ filterState, setFilterState }: UsersFilterProps) {
    const handleChange = (event: SelectChangeEvent) => {
        setFilterState({ userCategory: event.target.value as UserCategoryFilter })
    }

    const labelUserCategory = 'Kategori'

    return (
        <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
            <InputLabel id='user-category-filter'>{labelUserCategory}</InputLabel>
            <Select
                labelId='user-category-filter'
                id='user-category-filter-select'
                name='userCategory'
                label={labelUserCategory}
                onChange={handleChange}
                value={filterState.userCategory}
            >
                <MenuItem value='all'>Alla</MenuItem>
                {USER_CATEGORIES.map((category) => (
                    <MenuItem key={category} value={category}>
                        {userCategoryAdminLabel(category)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default UsersFilter
